module.exports = __webpack_public_path__ + "img/sponsor.7522551d.png";